import { signupFormSchema } from "@redotech/redo-model/signup-form-schema";
import * as z from "zod/v4";

export const createSignupForm = {
  name: "createSignupForm" as const,
  input: z.object({ form: signupFormSchema }),
  output: z.object({ formId: z.string() }),
};
